export default __webpack_public_path__ + "static/media/bandeau-1.e038270b.jpg";